import React from 'react';
import './LoadingState.css';

/** Spinner — shown while data is loading. */
export function LoadingState({ message = 'Loading…' }) {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="spinner" />
      <span>{message}</span>
    </div>
  );
}

/** EmptyState — shown when a list returns zero items. */
export function EmptyState({ message = 'No videos in this category yet.' }) {
  return (
    <div className="loading-screen" role="status">
      <i className="fa fa-film" style={{ fontSize: 40, marginBottom: 12 }} />
      <span>{message}</span>
    </div>
  );
}

/** ErrorState — shown when an API request fails. */
export function ErrorState({ message = 'Something went wrong.', onRetry }) {
  return (
    <div className="loading-screen" role="alert">
      <i className="fa fa-triangle-exclamation" style={{ fontSize: 40, marginBottom: 12 }} />
      <span>{message}</span>
      {onRetry && (
        <button className="back-btn" onClick={onRetry} style={{ marginTop: 16 }}>
          <i className="fa fa-rotate-right" /> Try again
        </button>
      )}
    </div>
  );
}

export default LoadingState;
